import emptyState from "../store/emptyState";
import { NativeActionConstants } from "../action-constants";
import globalReducerHelper from "./globalReducerHelper";

const native = (state = emptyState.native, action) => {
  if (!state) return {};

  const { type, payload } = action;

  switch (type) {
    case NativeActionConstants.INIT_STATE:
      return Object.assign({}, state, { ...payload });

    case NativeActionConstants.SET_BIOMETRICS_FLOW_ENABLED:
      return { ...state, isBiometricsFlowEnabled: action.payload };

    case NativeActionConstants.SET_BIOMETRICS_ENROLLMENT_STATUS:
      return { ...state, isBiometricsEnrolled: action.payload };

    default:
      return globalReducerHelper(
        state,
        type,
        payload && payload.native,
        emptyState.native
      );
  }
};

export default native;
